export class ProdutoCampanhaVendedor {
  public id: number;
  public id_product_campanha: number;
  public idseller: number;
  public data_inclusao: Date;
  public fullname: string;

  constructor() { }
}
